var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_notice"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.62 15.06C19.7533 15.06 18.24 13.5468 18.24 11.68C18.24 9.81333 19.7533 8.30005 21.62 8.30005C23.4867 8.30005 25 9.81333 25 11.68C25 13.5468 23.4867 15.06 21.62 15.06Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.17012 14.7699L21.6201 20.6899V2.67993L9.17012 8.58993V14.7699Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.16992 8.58984H4.34992C2.63992 8.58984 1.25992 9.96984 1.25992 11.6798C1.25992 13.3898 2.63992 14.7698 4.34992 14.7698H9.16992V8.58984Z",
    fill: "#FFCF02",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.16992 14.77H5.66992V22.01C5.66992 22.98 6.44992 23.76 7.41992 23.76C8.38992 23.76 9.16992 22.98 9.16992 22.01V14.77Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "bevel"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotice);
export default __webpack_public_path__ + "static/media/icon_notice.fd619013f37b7cb20b6cc741ab9a7b62.svg";
export { ForwardRef as ReactComponent };